import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

const Sustainability = () =>{
  return (
    <>
    <Header/>
    <Footer/>    
    </>
  )
}

export default Sustainability